import AdvisorDashboardWrapper from "./AdvisorDashboardWrapper";

export default AdvisorDashboardWrapper;
